var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 16,
    viewBox: "0 0 57 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00244141 8.13565L7.83108 15.9643L15.6597 8.13565L7.83108 0.307007L0.00244141 8.13565ZM56.3385 8.13565L48.5099 0.307007L40.6812 8.13565L48.5099 15.9643L56.3385 8.13565ZM7.83108 9.49161H48.5099V6.77969H7.83108V9.49161Z",
    fill: "url(#paint0_linear_42_324)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_324",
    x1: 2.40724,
    y1: 8.13565,
    x2: 55.9677,
    y2: 8.13565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BD3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086AD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon);
export default __webpack_public_path__ + "static/media/Line_icon.50ac3c27f83895955c80d7b9a5cdf172.svg";
export { ForwardRef as ReactComponent };